var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurkinaFaso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_6848)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_6848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_6848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 3H3V23H33V3Z",
    fill: "#009E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 3H3V13H33V3Z",
    fill: "#EF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.66663L16.9699 12.8368L18.555 13.3518",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.66663L19.0301 12.8368L17.445 13.3518",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1702 11.97H17.8368V13.6366",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1702 11.97L18.4734 13.9293L17.4938 12.5809",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9593 15.6967L18.9292 12.5265L17.3441 13.0415",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9593 15.6967L17.2626 13.7374L18.2422 12.389",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0407 15.6967L18.7374 13.7375L17.7578 12.3891",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0407 15.6967L17.0708 12.5266L18.6559 13.0416",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8298 11.97L17.5265 13.9293L18.5061 12.5809",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8298 11.97H18.1631V13.6366",
    fill: "#FCD116"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_6848",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_6848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_6848",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurkinaFaso);
export default __webpack_public_path__ + "static/media/BurkinaFaso.5c89d0e48dd151294de19cd68a105a1d.svg";
export { ForwardRef as ReactComponent };